import { NAMESPACE_SEARCH } from 'app/constants/Context';
import { selectAllConflictedIds } from 'app/modules/BetSlip/selectors/conflict';
import { selectBets } from 'app/modules/BetSlip/selectors/entries';
import * as entitySelectors from 'app/modules/Search/selectors';

export default {
  namespace: NAMESPACE_SEARCH,

  content: {
    selectors: entitySelectors,
  },

  staking: {
    selectors: {
      selectBets,
      selectAllConflictedIds,
    },
  },
};
